module.exports = __webpack_public_path__ + "img/koudai.141d56ea.webp";